export class ClassificationDoesNotExists extends Error { }
export class NoActiveClassification extends Error { }
export class NoActiveFeature extends Error { }
export class EmptyActiveMappedItemInput extends Error { }
export class FeatureDoesNotExists extends Error { }
export class ValueDoesNotExists extends Error { }